import {Component} from "@angular/core";
import {DxBaseControlComponent} from '../dx-base-control.component';
import {DxInputControlOptions} from '../../../domain/ui-options/dx-input-control-options';


/** Поле ввода. (!!!Подумать с типами вводимых данных!!!). */
@Component({
  selector: 'dx-file',
  templateUrl: './dx-file.component.html',
  styleUrls: ['./dx-file.component.css']
})
export class DxFileComponent extends DxBaseControlComponent {

  /** Опции контрола.*/
  public get controlOptions(): DxInputControlOptions {
    return <DxInputControlOptions> this.options;
  }

  protected _init(): void {
    super._init();
    if (!this.options) this.options = new DxInputControlOptions();
  }
}
